<!--
  Users tab, laid out like vendor-ref/mara/app/ui/src/components/nanome/WorkspaceMembers.vue and
  WorkspaceSharingControls.vue (Join via Code + Copy link, Link access, Public workspace, Permissions / My Org,
  add-people row, member list). Sharing needs a Nanome workspace, so every control is disabled and greyed under a
  blur with the shared nudge on top.
-->
<script setup lang="ts">
import { ref } from 'vue';
import Button from 'primevue/button';
import Select from 'primevue/select';
import ToggleSwitch from 'primevue/toggleswitch';
import InputText from 'primevue/inputtext';
import Badge from 'primevue/badge';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TeaserCta from './TeaserCta.vue';

const activeTab = ref('users');
const sharingLevel = ref('0');
const level = ref(2);
</script>

<template>
  <div class="relative min-h-0 flex-1 flex flex-col" data-test="users-tab">
    <div class="flex flex-col select-none pointer-events-none op-50" aria-hidden="true" inert>
      <!-- Join via Code -->
      <div class="flex items-end gap-2">
        <div class="mr-auto flex flex-col gap-1">
          <div class="op-50 text-xs">
            Join via Code
          </div>
          <div class="text-2xl font-bold tracking-wide blur-[5px]">
            XXXX-XXXX
          </div>
        </div>
        <Button icon="i-tabler-link" label="Copy link" severity="secondary" size="small" rounded disabled />
      </div>

      <div class="my-2 flex flex-col gap-3">
        <div class="flex items-center justify-between gap-4">
          <label class="text-sm">Link access</label>
          <Select
            v-model="sharingLevel"
            :options="[{ label: 'Members only', value: '0' }, { label: 'Anyone can view', value: '1' }, { label: 'Anyone can edit', value: '2' }]"
            pt:label="pr-0"
            option-label="label"
            option-value="value"
            class="w-175px rd-5"
            size="small"
            variant="filled"
            disabled
          />
        </div>
        <div class="flex items-center justify-between gap-4">
          <div class="flex flex-col">
            <label class="text-sm">Public workspace</label>
            <div class="op-50 text-xs">
              Allow anonymous viewers
            </div>
          </div>
          <ToggleSwitch :model-value="false" disabled />
        </div>
      </div>

      <Tabs v-model:value="activeTab" class="w-full min-h-0 flex flex-col">
        <TabList>
          <Tab value="users">
            Permissions
          </Tab>
          <Tab value="org">
            My Org
          </Tab>
        </TabList>
      </Tabs>

      <div class="pt-4 flex flex-col">
        <div class="flex gap-2 items-center mb-4">
          <InputText class="grow-1 min-w-0 rd-5" placeholder="Add people by email" size="small" disabled />
          <Select
            v-model="level"
            :options="[{ label: 'Viewer', value: 1 }, { label: 'Editor', value: 2 }]"
            option-label="label"
            option-value="value"
            class="w-7rem rd-5"
            size="small"
            variant="filled"
            disabled
          />
          <Button label="+ Add" size="small" rounded disabled />
        </div>
        <div class="pl-2 flex flex-col gap-2">
          <div class="h-8 flex items-center gap-2">
            <div class="w-2 h-2 rd-full bg-[#facc15]" />
            <div class="mr-auto truncate text-sm blur-[4px]">
              you@example.com
            </div>
            <Badge severity="secondary" value="Owner" />
          </div>
        </div>
      </div>
    </div>

    <div class="absolute inset-0 flex items-center justify-center p-4" data-test="users-overlay">
      <TeaserCta title="Share and collaborate in real time in Nanome" text="Invite people by email or code, set link access, and work in the same scene together." card />
    </div>
  </div>
</template>
